import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { replaceOwnerThreads } from '../messageThreads/messageThreadSlice'
import { setLoadFetchedMessages, setMessages } from './messageSlice'
import { setOwners } from '../owners/ownerSlice'
import { setUsers } from '../users/userSlice'
import { difference, pick } from 'lodash'

export const addMessage = createAsyncThunk(
  'app/addMessage',
  async ({ thread_id, message, unique_owner_id }, { dispatch, rejectWithValue, getState }) => {
    try {
      const response = await axios.post('/api/messaging/create_message', {
        thread_id,
        message,
        unique_owner_id,
      })

      const { message_threads, messages, owners, users } = response?.data || {}
      const state = getState()

      const existingThread = state.messageThreads?.[thread_id]
      const existingMessageIds = existingThread?.messages || []

      const updatedThread = message_threads?.[thread_id]
      const updatedMessageIds = updatedThread?.messages || []

      const newMessageIds = difference(updatedMessageIds, existingMessageIds)
      const newMessages = pick(messages, newMessageIds)

      if (message_threads) {
        dispatch(replaceOwnerThreads({ threads: message_threads, owner_id: unique_owner_id }))
      }

      if (messages) {
        dispatch(setLoadFetchedMessages(newMessages))
        dispatch(setMessages(newMessages))
      }

      if (owners) dispatch(setOwners(owners))
      if (users) dispatch(setUsers(users))

      return response?.data
    } catch (err) {
      console.error('Error in addMessage thunk:', err)
      return rejectWithValue(err?.response?.data || { error: 'Unexpected error' })
    }
  }
)
